import { Component, OnInit,ViewEncapsulation, ViewChild } from '@angular/core';
import { ConfirmationService, ConfirmEventType, LazyLoadEvent, MessageService, PrimeNGConfig } from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder } from '@angular/forms';
import { SharedService } from 'src/app/shared/services';
import {UserApprovalService} from'../../services/userapproval.service'
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { IUserDetails } from 'src/app/admin/models/user.model';

import { Router, ActivatedRoute ,NavigationStart} from '@angular/router';
@Component({
  selector: 'app-userapproval-search',
  templateUrl: './userapproval-search.component.html',
  styleUrls: ['./userapproval-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class UserapprovalSearchComponent implements OnInit {
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  startSearch: boolean = false;
  userApprovalList;
  gridSpinner = 'gridSpinner1';
  isSearchLoading: boolean = false;
  loading: boolean = false;
  userApprovalSearchParam:IGlobalSearchParam;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  showAddRuleButton:boolean = false;
  userApprovalSearchSpinner = 'userApprovalSearchSpinner';
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  gridGlobalFilter: SelectItem[];
  showTopFilters: boolean;
  @ViewChild('dt2', { static: true }) table: any;

  constructor( 
    private userApprovalService:UserApprovalService,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private _router: Router ) 
    {
       this.showFilters = false;
      this.showSorting = false;
      this.spinner.show();
      setTimeout(() => {
          this.spinner.hide();
      }, 1000);
      //setInterval(() =>  this.checkSessionTimeout(), 60000);
      // _router.events.forEach((event) => {
      //   if (event instanceof NavigationStart) {
      //      if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
           
      //      }
      //      else {
      //       var isTokenAvailable = this.sharedService.isTokenAvailable();
           
      //       if(isTokenAvailable){
      //       setInterval(() =>  this.checkSessionTimeout(), 60000);
      //       }        
      //      }
      //     }
      // });
    }

  ngOnInit(): void {
    this.checkViewPermission();
    const customFilterName = "custom-equals";
      const dateAfter = "date-after";
      const dateBefore = "date-before";

      this.matchModeOptions = [
        { label: "Custom Equals", value: customFilterName },
        { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
        { label: "Contains", value: FilterMatchMode.CONTAINS }
      ];

      this.matchModeOptionsForDate = [
        { label: "Custom Equals", value: customFilterName },
        { label: "Date After", value: dateAfter },
        { label: "Date Before", value: dateBefore },
      ];

      this.matchModeOptionsForNumeric = [
        { label: "Custom Equals", value: customFilterName },
        { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
      ];
      this.filterCondition=[
        {fieldName:"firstName",type:"basic"},
        {fieldName:"lastName",type:"basic"},
        {fieldName:"companyName",type:"basic"},
        {fieldName:"createdOn",type:"date"},

      ];
      this.getUserApprovalList();
  }

  checkSessionTimeout()
  {

    var isTokenAvailable = this.sharedService.isTokenAvailable();
    //console.log('Session app' + isTokenAvailable);
    if(isTokenAvailable){
      var result = this.sharedService.checkSessionTimeout();
     // console.log('Session app' + result);
       if(!result) {
         localStorage.removeItem('VMS');
         localStorage.clear();
         this._router.navigateByUrl('/login');
       }
    } 
   
  }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }
  getUserApprovalList()
  {
    this.userApprovalSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.userApprovalSearchSpinner);
    this.userApprovalService.getAllUserApprovalList(this.userApprovalSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.userApprovalList =data;
      console.log(this.userApprovalList);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.userApprovalSearchSpinner);
     });
  }

  loadUserApprovalList(event:LazyLoadEvent)
  { 
    this.appliedFilters = [];
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
    this.getUserApprovalList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButton = true;
    }
    else{
      this.showAddRuleButton = false;
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.getUserApprovalList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }
   
  
  applyFilter()
  {
    if (Object.keys(this.filters).length > 1)
    {
      this.appliedFilters = [];
    for(let i=0;i<this.filterCondition.length;i++)
    {
      if(this.filterCondition[i].type == "checkbox")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value == true)
        {
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"true"}) 
        }
        else if (this.filters[this.filterCondition[i].fieldName][0].value == false){
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"false"}) 
        }
      }
      else if (this.filterCondition[i].type == "basic")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
        this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                  matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                  value:this.filters[this.filterCondition[i].fieldName][0].value }) 
      }
      else if (this.filterCondition[i].type == "date")
      {
        for(let j=0; j<= this.filters[this.filterCondition[i].fieldName].length-1; j++)
        {
          if(this.filters[this.filterCondition[i].fieldName][j].value !== null)
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][j].matchMode,
                                    value:this.filters[this.filterCondition[i].fieldName][j].value }) 
        }
      }
      else if (this.filterCondition[i].type == "numeric")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
        this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                  matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                  value:this.filters[this.filterCondition[i].fieldName][0].value }) 
      }

      
      // if(i==this.filterCondition.length-1 )
      // {
      //   this.startSearch = true; 
      // }
      
      
    }
    }
    

    //////////////////
      
    this.searchGlobalFilter = [];
      

    ///////////////////

    //if(this.startSearch == true)
    if(this.startSearch == true || this.startSearch == false)
    {
      this.userApprovalSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
      this.spinner.show(this.userApprovalSearchSpinner);
      this.userApprovalService.getAllUserApprovalList(this.userApprovalSearchParam).subscribe((data: any) => {
      //this.appliedFilters = [];
      this.userApprovalList =data;
      console.log(this.userApprovalList);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.userApprovalSearchSpinner);
      });
    }
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    // this.applyFilter();
    this.getUserApprovalList();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }
  
  changeGlobalFilter(event) {
    
  }

  saveFilter()
  {

  }
  approveUser(userDetail:IUserDetails)
  {
    var id = userDetail.userProfileId;
    userDetail.isApproved = true;
    userDetail.isActive = true;
    this.userApprovalService.approveUser(id,userDetail).subscribe((data:any) =>{
      this.getUserApprovalList();
    })
  }
}
